import { InquiryForm } from "./InquiryForm";
import { useContent } from "../../Core/Content/Provider";
import { RouteConstants } from "../../Core/Constants/RouteConstants";
import { PageHeaderPiece } from "../../Shared/Layout/Pieces";
import { ButtonPiece } from "../../Shared/UI/ButtonPiece";
import { getContactChannelsFn, getContactPromptsFn } from "./Functions";
import { ContactChannelPiece, ContactPromptPiece } from "./Pieces";

export const ContactComponent = () => {
  const content = useContent("contact");
  const channels = getContactChannelsFn();
  const prompts = getContactPromptsFn();

  return (
    <section className="section-shell">
      <PageHeaderPiece
        eyebrow={content.eyebrow}
        title={content.title}
        description={content.description}
      />
      <div className="grid gap-6 lg:grid-cols-[0.9fr_1.1fr]">
        <div className="panel-surface studio-contact-card p-6 sm:p-8">
          <p className="text-xs font-black uppercase text-cmj-gold">
            Contact channels
          </p>
          <div className="mt-5 grid gap-4">
            {channels.map((channel) => (
              <ContactChannelPiece
                key={channel.label}
                label={channel.label}
                value={channel.value}
              />
            ))}
          </div>
        </div>
        <div className="panel-surface p-6 sm:p-8">
          <p className="text-xs font-black uppercase text-cmj-gold">
            Good reasons to reach out first
          </p>
          <ul className="mt-5 grid gap-4">
            {prompts.map((prompt) => (
              <ContactPromptPiece key={prompt} prompt={prompt} />
            ))}
          </ul>
          <div className="mt-8 flex flex-wrap gap-3">
            <ButtonPiece appearance="secondary" to={RouteConstants.booking}>
              Start a Booking
            </ButtonPiece>
            <ButtonPiece appearance="ghost" to={RouteConstants.packages}>
              Review Packages
            </ButtonPiece>
          </div>
        </div>
      </div>
      <InquiryForm />
    </section>
  );
};
